import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './icon.component';
import { NzIconModule } from 'ng-zorro-antd/icon';


@NgModule({
  declarations: [IconComponent],
  imports: [
    CommonModule,
    NzIconModule,
  ],
  exports: [IconComponent],
})
export class IconModule { }
